import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';

const initialState = {
  isLoading: false,
  error: false,
  divisions: []
};

const slice = createSlice({
  name: 'division',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getDivisionsSuccess(state, action) {
      state.isLoading = false;
      state.divisions = action.payload;
    }
  }
});

export default slice.reducer;

export function getDivisions() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/division/all');
      dispatch(slice.actions.getDivisionsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
